import { render, staticRenderFns } from "./NavbarTopActivity.vue?vue&type=template&id=1454ffb2"
import script from "./NavbarTopActivity.vue?vue&type=script&lang=js"
export * from "./NavbarTopActivity.vue?vue&type=script&lang=js"
import style0 from "./NavbarTopActivity.vue?vue&type=style&index=0&id=1454ffb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports